import {z} from 'zod';

import type {KyResponse} from 'ky';

const paginationSchema = z
  .object({
    top: z.number(),
    skip: z.number(),
    count: z.number(),
    pages: z.number(),
    hasNext: z.boolean(),
    hasPrevious: z.boolean(),
  })
  .nullable();

type Pagination = z.infer<typeof paginationSchema>;

/**
 * Extract pagination parameters from api response headers
 * @param res KyResponse instance
 * @returns pagination information if it exists
 */
export function extractPagination(res: KyResponse): Pagination | null {
  const header = res.headers.get('X-Pagination');

  if (!header) return null;

  return paginationSchema.parse(JSON.parse(header));
}
